import { render, staticRenderFns } from "./ServicePromotion.vue?vue&type=template&id=55d2a473"
import script from "./ServicePromotion.vue?vue&type=script&lang=js"
export * from "./ServicePromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports